import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Global } from '../../shared/global';
import { ISettings } from '../models/settings';

@Injectable({
  providedIn: 'root'
})
export class SettingsService {
  public settings: ISettings;

  constructor(private http: HttpClient) { }

  loadSettings(): Promise<void> {
    return new Promise<void>(resolve => {
      const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
      const options = { headers: headers };
      this.http.get<ISettings>(Global.BASE_SETTINGS_ENDPOINT + 'getsettings', options).toPromise().then((settings) => {
        this.settings = settings;
        resolve();
      });
    });
  }
}
